import { render } from "./BaseGallery.vue?vue&type=template&id=1af809d5"
import script from "./BaseGallery.vue?vue&type=script&lang=js"
export * from "./BaseGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__